import type { App, Directive, DirectiveBinding } from 'vue';
import { hasAnyPerm, hasPerm } from './permission';

/**
 * v-perm="'order:assign'"        单个权限码
 * v-perm="['order:assign','x']"  任一命中即可（or 语义）
 * v-perm:disable="'order:cancel'" 无权限时禁用而非隐藏（保留可发现性 + tooltip）
 */

type PermValue = string | string[] | null | undefined;

function evaluate(value: PermValue): boolean {
  if (Array.isArray(value)) return hasAnyPerm(value);
  return hasPerm(value);
}

function apply(el: HTMLElement, binding: DirectiveBinding<PermValue>): void {
  const allowed = evaluate(binding.value);
  if (allowed) {
    el.style.removeProperty('display');
    el.removeAttribute('disabled');
    el.classList.remove('is-disabled');
    el.removeAttribute('title');
    return;
  }

  if (binding.arg === 'disable') {
    el.setAttribute('disabled', 'disabled');
    el.classList.add('is-disabled');
    el.setAttribute('title', '无操作权限，请联系管理员分配');
    el.style.pointerEvents = 'none';
    return;
  }

  el.style.display = 'none';
}

export const permDirective: Directive<HTMLElement, PermValue> = {
  mounted: apply,
  updated: apply,
};

export function installPermissionDirectives(app: App): void {
  app.directive('perm', permDirective);
}
